import { useNavigate } from 'react-router-dom';
import { useMemo, useState, useCallback } from 'react';
import useResizeObserver from 'use-resize-observer';
import { debounce } from 'lodash';
import { searchToObj } from '../utils';
export { default as useSorting } from './useSorting';
export { useContainerReady } from './useContainerReady';

export function useSearchParamsValue(): { [key: string]: string } {
  const search = window.location.search;
  const params = useMemo(() => searchToObj(search), [search]);
  return params;
}

export function useSearchParams() {
  const navigate = useNavigate();

  const setParams = useCallback(
    ({ newParams, newExtraParams, merge = true }: any) => {
      const params = searchToObj(window.location.search);
      const merged = merge
        ? newExtraParams
          ? { ...params, ...newParams, ...newExtraParams }
          : { ...params, ...newParams }
        : newParams;
      const url = window.location?.pathname + '?' + new URLSearchParams(merged).toString();
      navigate(url.replace(/\+/g, '%20'));
    },
    [history],
  );

  return { setParams };
}

export function useDebouncedResizeObserver(wait: number) {
  const [size, setSize] = useState({});
  const onResize = useMemo(() => debounce(setSize, wait, { leading: true }), [wait]);
  const { ref } = useResizeObserver({ onResize });

  return { ref, size };
}
